import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type ActivatePendingAccountMutationVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type ActivatePendingAccountMutationResult = { __typename?: 'Mutation' } & {
  activatePendingAccount?: GraphQLTypes.Maybe<
    { __typename?: 'ActivatePendingAccountPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const ActivatePendingAccountDocument = gql`
  mutation activatePendingAccount($accountId: String!) {
    activatePendingAccount(accountId: $accountId) {
      errors {
        message
        path
      }
    }
  }
`;
